(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    // 使用事件委托，在 document 上监听点击事件
    // 这样即使 DOM 更新，事件监听器仍然有效
    document.addEventListener('click', function(event) {
      // 首先排除 facet-floating-filter 及其内部元素的点击
      const facetFloatingFilter = event.target.closest('facet-floating-filter');
      if (facetFloatingFilter) return;

      // 检查点击的是否是 .yg-sort_by 或其子元素
      const ygSortBy = event.target.closest('.yg-sort_by');
      if (!ygSortBy) return;

      const facetsDrawer = document.getElementById('facets-drawer');
      if (!facetsDrawer || typeof facetsDrawer.show !== 'function') return;

      // 打开抽屉
      facetsDrawer.show().then(function() {
        // 等待抽屉打开后，检查并触发 accordion toggle
        setTimeout(function() {
          const accordion = document.querySelector('#facet-form #accordion-sort-by');
          const toggle = accordion?.querySelector('.accordion__toggle');
          
          if (accordion && toggle) {
            // 如果 accordion 已经打开，就不需要再触发 toggle
            if (accordion.open) {
              return;
            }
            
            // 如果 accordion 还没打开，则打开它并触发 toggle
            accordion.setAttribute('open', '');
            accordion.setAttribute('aria-expanded', 'true');
            // 触发点击事件来确保所有相关事件都被触发
            toggle.click();
          }
        }, 100);
      });
    });

    // Collection tabs 滚动和导航按钮功能
    function initCollectionTabs() {
      const tabsHeaders = document.querySelectorAll('.collection__tabs-header');
      
      tabsHeaders.forEach(function(header) {
        const wrapper = header.querySelector('.collection__tabs-wrapper');
        const prevBtn = header.querySelector('.collection__tabs-nav-btn--prev');
        const nextBtn = header.querySelector('.collection__tabs-nav-btn--next');
        
        if (!wrapper || !prevBtn || !nextBtn) return;

        function updateNavButtons() {
          const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth - 1;
          const currentScroll = wrapper.scrollLeft;
          prevBtn.classList.toggle('is-visible', currentScroll > 0);
          nextBtn.classList.toggle('is-visible', currentScroll < maxScrollLeft);
        }

        function getItemScrollWidth() {
          const firstItem = wrapper.querySelector('.collection__tab');
          if (!firstItem) return 0;
          const style = window.getComputedStyle(firstItem);
          const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
          return firstItem.offsetWidth + margin;
        }

        function scrollLeft() {
          const amount = getItemScrollWidth() || wrapper.clientWidth * 0.8;
          wrapper.scrollBy({ left: -amount, behavior: 'smooth' });
        }

        function scrollRight() {
          const amount = getItemScrollWidth() || wrapper.clientWidth * 0.8;
          wrapper.scrollBy({ left: amount, behavior: 'smooth' });
        }

        function scrollActiveIntoView() {
          const activeTab = wrapper.querySelector('.collection__tab.active');
          if (activeTab) {
            const targetLeft = Math.max(activeTab.offsetLeft - 25, 0);
            wrapper.scrollTo({ left: targetLeft, behavior: 'smooth' });
            setTimeout(updateNavButtons, 200);
          }
        }

        prevBtn.addEventListener('click', function() {
          scrollLeft();
          setTimeout(updateNavButtons, 200);
        });

        nextBtn.addEventListener('click', function() {
          scrollRight();
          setTimeout(updateNavButtons, 200);
        });

        wrapper.addEventListener('scroll', updateNavButtons, { passive: true });
        window.addEventListener('resize', updateNavButtons);
        
        // 初始化按钮状态
        updateNavButtons();
        // 滚动到当前 active tab
        scrollActiveIntoView();
      });
    }

    // 页面加载完成后初始化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollectionTabs);
    } else {
      initCollectionTabs();
    }

    // 监听 DOM 更新（facet:update 事件）
    document.addEventListener('facet:update', function() {
      setTimeout(initCollectionTabs, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-all-brand"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGAllBrand extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
  
      init() {
        /* =====================
         * 常量
         * ===================== */
        this.ACTIVE_OFFSET = window.innerWidth <= 699 ? 117 : 150; // 移动端 (<=699px) 使用 100px 偏移，其他使用 150px
  
        /* =====================
         * 元素缓存
         * ===================== */
        this.top = this.querySelector('.yg-brand-top');
        this.wrapper = this.querySelector('.yg-brand-letter-wrapper');
        this.letters = Array.from(
          this.querySelectorAll('.yg-brand-top .yg-brand-letter')
        );
        this.items = Array.from(this.querySelectorAll('.yg-brand-item'));
  
        this.prevBtn = this.querySelector('.yg-brand-nav-btn--prev');
        this.nextBtn = this.querySelector('.yg-brand-nav-btn--next');
  
        if (!this.letters.length || !this.items.length) return;
  
        this.bindClick();
        this.bindObserver();
        this.bindNavButtons();
      }
  
      /* =====================
       * 点击字母 → 滚动到 item（top = 200px）
       * ===================== */
      bindClick() {
        this.letters.forEach(letter => {
          letter.addEventListener('click', () => {
            const targetId = `yg-brand-${letter.dataset.letter.toLowerCase()}`;
            const target = this.querySelector(`#${targetId}`);
            if (!target) return;
  
            const top =
              target.getBoundingClientRect().top +
              window.scrollY -
              this.ACTIVE_OFFSET;
  
            window.scrollTo({
              top,
              behavior: 'smooth',
            });
  
            // this.setActive(letter.dataset.letter);
            this.scrollLetterIntoView(letter);
          });
        });
      }
  
      /* =====================
       * 滚动监听 → item 顶部到 200px 才激活
       * ===================== */
      bindObserver() {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
  
              const letter = entry.target.id
                .replace('yg-brand-', '')
                .toUpperCase();
  
              this.setActive(letter);
  
              const activeBtn = this.letters.find(
                l => l.dataset.letter === letter
              );
  
              this.scrollLetterIntoView(activeBtn);
            });
          },
          {
            root: null,
            threshold: 0,
            // 顶部 200px 作为触发线
            rootMargin: `-${this.ACTIVE_OFFSET}px 0px -70% 0px`,
          }
        );
  
        this.items.forEach(item => observer.observe(item));
      }
  
      /* =====================
       * 设置 active 状态
       * ===================== */
      setActive(letter) {
        this.letters.forEach(l =>
          l.classList.toggle('active', l.dataset.letter === letter)
        );
      }
  
      /* =====================
       * 顶部字母左右滚动（移动端）
       * ===================== */
      bindNavButtons() {
        if (!this.wrapper || !this.prevBtn || !this.nextBtn) return;
  
        const update = () => {
          const max =
            this.wrapper.scrollWidth - this.wrapper.clientWidth - 1;
          this.prevBtn.classList.toggle(
            'is-visible',
            this.wrapper.scrollLeft > 0
          );
          this.nextBtn.classList.toggle(
            'is-visible',
            this.wrapper.scrollLeft < max
          );
        };
  
        this.prevBtn.addEventListener('click', () => {
          this.wrapper.scrollBy({
            left: -120,
            behavior: 'smooth',
          });
        });
  
        this.nextBtn.addEventListener('click', () => {
          this.wrapper.scrollBy({
            left: 120,
            behavior: 'smooth',
          });
        });
  
        this.wrapper.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
  
      /* =====================
       * 确保当前字母在可视区域
       * ===================== */
      scrollLetterIntoView(letter) {
        if (!letter || !this.wrapper) return;
  
        const left = letter.offsetLeft - 20;
        this.wrapper.scrollTo({
          left,
          behavior: 'smooth',
        });
      }
    }
  
    if (!window.customElements.get('yg-all-brand')) {
      window.customElements.define('yg-all-brand', YGAllBrand);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collaspe-content"] && !Shopify.designMode) return;
  try {
    
class YgCollapseSection extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.yg-collaspe-btn');
    this.content = this.querySelector('.yg-item-content');
    this.contentContainer = this.querySelector('.yg-collaspe-content');
    
    // 获取配置属性
    this.moreText = this.getAttribute('data-more') || 'Show More';
    this.lessText = this.getAttribute('data-less') || 'Show Less';
    
    this.init();
  }

  init() {
    // 初始化时添加clamped类
    this.content.classList.add('clamped');
    
    // 绑定点击事件
    this.button.addEventListener('click', () => {
      this.toggleContent();
    });
  }

  toggleContent() {
    const isExpanded = this.contentContainer.classList.contains('expanded');
    
    if (isExpanded) {
      // 收起内容
      this.contentContainer.classList.remove('expanded');
      this.content.classList.add('clamped');
      this.button.textContent = this.moreText;
    } else {
      // 展开内容
      this.contentContainer.classList.add('expanded');
      this.content.classList.remove('clamped');
      this.button.textContent = this.lessText;
    }
  }
}

// 注册自定义元素
customElements.define('yg-collapse-section', YgCollapseSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collection-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGCollectionTab extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.tabButtons = Array.from(this.querySelectorAll('.yg-tab-item'));
        this.contents = Array.from(this.querySelectorAll('.yg-tab-content'));
        this.wrapper = this.querySelector('.yg-tab-item-wrapper');
        this.prevBtn = this.querySelector('.yg-tab-nav-btn--prev');
        this.nextBtn = this.querySelector('.yg-tab-nav-btn--next');

        if (!this.tabButtons.length) return;

        this.handleTabClick = this.handleTabClick.bind(this);
        this.handlePrevTab = this.handlePrevTab.bind(this);
        this.handleNextTab = this.handleNextTab.bind(this);
        this.updateNavButtons = this.updateNavButtons.bind(this);
        this.scrollLeft = this.scrollLeft.bind(this);
        this.scrollRight = this.scrollRight.bind(this);
        this.scrollItemIntoView = this.scrollItemIntoView.bind(this);

        this.tabButtons.forEach((btn) => btn.addEventListener('click', this.handleTabClick));

        if (this.prevBtn && this.nextBtn && this.wrapper) {
          this.prevBtn.addEventListener('click', this.handlePrevTab);
          this.nextBtn.addEventListener('click', this.handleNextTab);
          this.wrapper.addEventListener('scroll', this.updateNavButtons, { passive: true });
          window.addEventListener('resize', this.updateNavButtons);
          this.updateNavButtons();
        }
      }

      handleTabClick(event) {
        const index = Number(event.currentTarget.dataset.index);
        this.scrollItemIntoView(event.currentTarget);
        this.setActiveTab(index);
      }

      setActiveTab(index) {
        this.tabButtons.forEach((btn) => btn.classList.toggle('active', Number(btn.dataset.index) === index));
        this.contents.forEach((content) => content.classList.toggle('active', Number(content.dataset.index) === index));

        const activeContent = this.contents.find((content) => Number(content.dataset.index) === index);
        const swiperEl = activeContent?.querySelector('yg-collection-swiper');
        if (swiperEl?.swiperInstance) {
          swiperEl.swiperInstance.update();
        }
      }

      getItemScrollWidth() {
        const firstItem = this.wrapper?.querySelector('.yg-tab-item');
        if (!firstItem) return 0;
        const style = window.getComputedStyle(firstItem);
        const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        return firstItem.offsetWidth + margin;
      }

      scrollLeft() {
        const amount = this.getItemScrollWidth() || this.wrapper.clientWidth * 0.8;
        this.wrapper.scrollBy({ left: -amount, behavior: 'smooth' });
      }

      scrollRight() {
        const amount = this.getItemScrollWidth() || this.wrapper.clientWidth * 0.8;
        this.wrapper.scrollBy({ left: amount, behavior: 'smooth' });
      }

      handlePrevTab() {
        const activeIndex = this.getActiveIndex();
        const prevIndex = Math.max(activeIndex - 1, 0);
        const targetBtn = this.tabButtons[prevIndex];
        this.scrollLeft();
        this.setActiveTab(prevIndex);
        this.scrollItemIntoView(targetBtn);
      }

      handleNextTab() {
        const activeIndex = this.getActiveIndex();
        const nextIndex = Math.min(activeIndex + 1, this.tabButtons.length - 1);
        const targetBtn = this.tabButtons[nextIndex];
        this.scrollRight();
        this.setActiveTab(nextIndex);
        this.scrollItemIntoView(targetBtn);
      }

      getActiveIndex() {
        const activeBtn = this.tabButtons.find((btn) => btn.classList.contains('active'));
        return activeBtn ? Number(activeBtn.dataset.index) : 0;
      }

      scrollItemIntoView(btn) {
        if (!this.wrapper || !btn) return;
        const targetLeft = Math.max(btn.offsetLeft - 25, 0);
        this.wrapper.scrollTo({ left: targetLeft, behavior: 'smooth' });
        // ensure nav buttons visibility updates after scroll finishes
        window.setTimeout(this.updateNavButtons, 200);
      }

      updateNavButtons() {
        if (!this.wrapper || !this.prevBtn || !this.nextBtn) return;
        const maxScrollLeft = this.wrapper.scrollWidth - this.wrapper.clientWidth - 1;
        const currentScroll = this.wrapper.scrollLeft;
        this.prevBtn.classList.toggle('is-visible', currentScroll > 0);
        this.nextBtn.classList.toggle('is-visible', currentScroll < maxScrollLeft);
      }
    }

    if (!window.customElements.get('yg-collection-tab')) {
      window.customElements.define('yg-collection-tab', YGCollectionTab);
    }

    class YGCollectionSwiper extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        if (this.swiperInstance || typeof Swiper === 'undefined') return;

        const paginationEl = this.querySelector('.swiper-pagination');
        const prevEl = this.querySelector('.swiper-button-prev');
        const nextEl = this.querySelector('.swiper-button-next');

        this.swiperInstance = new Swiper(this, {
          slidesPerView: 4,
          spaceBetween: 24,
          watchOverflow: true,
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
            type: 'fraction'
          },
          breakpoints: {
            0: {
              slidesPerView: 2,
              grid: {
                rows: 2,
                fill: 'row',
              },
              spaceBetween: 12,
            },
            700: {
              slidesPerView: 3,
              grid: false,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 4,
              grid: false,
              spaceBetween: 16,
            },
          },
        });
      }
    }

    if (!window.customElements.get('yg-collection-swiper')) {
      window.customElements.define('yg-collection-swiper', YGCollectionSwiper);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-coupons-promotions"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        class YGCouponsPromotions extends HTMLElement {
            constructor() {
                super();
                this.init()
            }

            init() {
                const viewMore = this.querySelector('.yg-view-more');
                viewMore.addEventListener('click', () => {
                    if(this.classList.contains('open')) {
                        this.classList.remove('open');
                        viewMore.innerHTML = 'View More';
                        this.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                        });
                    } else {
                        this.classList.add('open');
                        viewMore.innerHTML = 'View Less';

                        
                    }
                });

                const disclaimers = this.querySelectorAll('.yg-disclaimer-text-wrapper');
                const items = this.querySelectorAll('.yg-coupons-promotions-item');
                let maxHeight = 0;

                disclaimers.forEach(disclaimer => {
                    if(disclaimer.scrollHeight > maxHeight) {
                        maxHeight = disclaimer.scrollHeight;
                    }
                });
            
                items.forEach(item => {
                    if(item.scrollHeight > maxHeight) {
                        maxHeight = item.scrollHeight;
                    }
                });

                items.forEach(item => {
                    item.style.height = maxHeight + 'px';
                });
            }
        }

        if (!window.customElements.get('yg-coupons-promotions')) {
        window.customElements.define('yg-coupons-promotions', YGCouponsPromotions);
        }

        class YGCouponsPromotionsItem extends HTMLElement {
            constructor() {
                super();
                this.init()
            }

            init() {
                const openButton = this.querySelector('.yg-disclaimer-button-open');
                const closeButton = this.querySelector('.yg-disclaimer-button-close');
                
                openButton.addEventListener('click', () => {
                    this.classList.add('active');
                });

                closeButton.addEventListener('click', () => {
                    this.classList.remove('active');
                });
            }
        }

        if (!window.customElements.get('yg-coupons-promotions-item')) {
        window.customElements.define('yg-coupons-promotions-item', YGCouponsPromotionsItem);
        }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-icon-introduce"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YgIconCollapse extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.yg-item-link');
    this.content = this.querySelector('.yg-item-text');

    this.moreText = this.getAttribute('data-more') || 'Show More';
    this.lessText = this.getAttribute('data-less') || 'Show Less';

    this._onToggle = this._onToggle.bind(this);
  }

  connectedCallback() {
    if (!this.button || !this.content) return;

    this._applyCollapsed();
    this.button.textContent = this.moreText;
    this.dataset.expanded = 'false';

    this.button.addEventListener('click', this._onToggle);
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this._onToggle);
    }
  }

  _applyCollapsed() {
    const textEl = this.content;
    textEl.style.display = '-webkit-box';
    textEl.style.webkitBoxOrient = 'vertical';
    textEl.style.overflow = 'hidden';
    textEl.style.textOverflow = 'ellipsis';
    textEl.style.webkitLineClamp = '3';
  }

  _clearCollapsed() {
    const textEl = this.content;
    textEl.style.display = '';
    textEl.style.webkitBoxOrient = '';
    textEl.style.overflow = '';
    textEl.style.textOverflow = '';
    textEl.style.webkitLineClamp = '';
  }

  _onToggle(event) {
    event.preventDefault();

    const isExpanded = this.dataset.expanded === 'true';
    if (isExpanded) {
      // 收起
      this._applyCollapsed();
      this.dataset.expanded = 'false';
      this.button.textContent = this.moreText;
    } else {
      // 展开
      this._clearCollapsed();
      this.dataset.expanded = 'true';
      this.button.textContent = this.lessText;
    }
  }
}

if (!customElements.get('yg-icon-collapse')) {
  customElements.define('yg-icon-collapse', YgIconCollapse);
}

  class YGItemTitleEqualizer extends HTMLElement {
    constructor() {
      super();
      this._minWidth = 700;
      this._selector = ".yg-item-title";
      this._debounceTimer = null;
      this._onResize = this._onResize.bind(this);
      this._onMutations = this._onMutations.bind(this);
    }

    connectedCallback() {
      this._observe();
      this._scheduleUpdate();
    }

    disconnectedCallback() {
      this._teardown();
    }

    _observe() {
      window.addEventListener("resize", this._onResize);
      this._mutationObserver = new MutationObserver(this._onMutations);
      try {
        this._mutationObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class", "style"]
        });
      } catch (e) {
        // ignore if observe fails in older browsers
      }
    }

    _teardown() {
      window.removeEventListener("resize", this._onResize);
      this._mutationObserver?.disconnect();
      this._clearDebounce();
    }

    _onResize() {
      this._scheduleUpdate();
    }

    _onMutations() {
      this._scheduleUpdate();
    }

    _clearDebounce() {
      if (this._debounceTimer) {
        clearTimeout(this._debounceTimer);
        this._debounceTimer = null;
      }
    }

    _scheduleUpdate() {
      this._clearDebounce();
      this._debounceTimer = setTimeout(() => {
        this._debounceTimer = null;
        this._updateHeights();
      }, 80);
    }

    _updateHeights() {
      try {
        if (window.innerWidth < this._minWidth) {
          this._resetHeights();
          return;
        }
        const nodes = Array.from(document.querySelectorAll(this._selector));
        if (!nodes.length) return;
        nodes.forEach((n) => { n.style.height = ""; });
        let max = 0;
        nodes.forEach((n) => {
          const h = Math.ceil(n.getBoundingClientRect().height);
          if (h > max) max = h;
        });
        if (max > 0) {
          nodes.forEach((n) => { n.style.height = `${max}px`; });
        }
      } catch (e) {
        // swallow errors to avoid breaking page
        console.error("yg-item-title-equalizer error:", e);
      }
    }

    _resetHeights() {
      const nodes = Array.from(document.querySelectorAll(this._selector));
      nodes.forEach((n) => { n.style.height = ""; });
    }
  }

  if (!window.customElements.get("yg-item-title-equalizer")) {
    window.customElements.define("yg-item-title-equalizer", YGItemTitleEqualizer);
  }

  try {
    if (!document.querySelector("yg-item-title-equalizer")) {
      const el = document.createElement("yg-item-title-equalizer");
      document.body.appendChild(el);
    }
  } catch (e) {}
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-icon-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class YGIconListBox extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.initSwiper();
        this.initTimelineInteraction();
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        const swiperEl = this.querySelector('.swiper');
        const mobileColumns = parseInt(this.dataset.mobileColumns) || 3;
        const desktopColumns = parseInt(this.dataset.desktopColumns) || 7;

        this.swiperInstance = new Swiper(swiperEl, {
          spaceBetween: 16, 
          slidesPerView: mobileColumns,
          grid: {
            rows: 2,
            fill: 'row',
          },
          breakpoints: { 
            700: { 
              spaceBetween: 24, 
              slidesPerView: desktopColumns, 
              grid: {
                rows: 1,
              },
            },
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });

      }

    }

    if (!customElements.get('yg-icon-list-box')) {
      customElements.define('yg-icon-list-box', YGIconListBox);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-cards-swiper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class YGImageCardsSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.initSwiper();
        this.initTimelineInteraction();
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        const hasColumns = this.hasAttribute('data-columns');
        this.prevBtn = this.querySelector('.swiper-button-prev');
        this.nextBtn = this.querySelector('.swiper-button-next');
        const slidesPerView700 = hasColumns ? 4 : 3.1;
        const slidesPerView699 = hasColumns ? 1.1 : 1;

        this.swiperInstance = new Swiper(this, {
          spaceBetween: 16, 
          slidesPerView: slidesPerView699,
          breakpoints: { 
            700: { 
              spaceBetween: 16, 
              slidesPerView: slidesPerView700, 
            }, 
          },
          navigation: { 
            nextEl: this.nextBtn, 
            prevEl: this.prevBtn, 
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          }
        });

      }

    }

    if (!customElements.get('yg-image-cards-swiper')) {
      customElements.define('yg-image-cards-swiper', YGImageCardsSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-popular-brand"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGPopularBrand extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        if (this.swiperInstance || typeof Swiper === 'undefined') return;

        const paginationEl = this.querySelector('.swiper-pagination');
        const prevEl = this.querySelector('.swiper-button-prev');
        const nextEl = this.querySelector('.swiper-button-next');

        this.swiperInstance = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: 3,
          spaceBetween: 12,
          watchOverflow: true,
          navigation: {
            nextEl,
            prevEl,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            0: {
              slidesPerView: 3,
              spaceBetween: 12,
            },
            700: {
              slidesPerView: 5,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 6,
              spaceBetween: 24,
            },
          },
          on: {
            init: event => {
              const brandIcon = this.querySelector('.yg-brand-icon');
              this.style.setProperty('--yg-brand-icon-height', brandIcon.offsetHeight + 'px');
            }
          }
        });
      }
    }

    if (!window.customElements.get('yg-popular-brand')) {
      window.customElements.define('yg-popular-brand', YGPopularBrand);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-faq22"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class YGProductTab extends HTMLElement {
      constructor() {
        super();
        this._onScroll = this._onScroll.bind(this);
        this._observe = this._observe.bind(this);
        this.handleQuantityChange = this.sync.bind(this);
        this.handleYgDecreaseClick = () => { this.decreaseBtn?.click(); };
        this.handleYgIncreaseClick = () => { this.increaseBtn?.click(); };
        this.handleVariantSelectChange = this._onVariantSelectChange.bind(this);
        this.handleMainVariantChange = this._onMainVariantChange.bind(this);
        this.addToCartTargets = [
          '.product-info__buy-buttons .button[type="submit"]',
          'button[name="add"]',
          '#AddToCart',
          '.product-form__submit',
        ];
        this.proxyButton = null;
        this.mutationObserver = null;
        this.quantityObserver = null;
        this.visibilityObserver = null;
        this.variantObserver = null;
        this.variantInputs = [];
        this.variantInputsByIndex = {};
        this.variantSelects = [];
        this._updateVisibility = this._updateVisibility.bind(this);
        this.ygNumber = this.querySelector('.yg-product-number');
        this.ygDecreaseBtn = this.querySelector('.yg-number-decrease');
        this.ygIncreaseBtn = this.querySelector('.yg-number-increase');
        this.ygVariantSelectsContainer = this.querySelector('.yg-variant-selects');

        // Shopify 元素
        this.quantityInput = null;
        this.decreaseBtn = null;
        this.increaseBtn = null;
        this.boundYgDecreaseBtn = null;
        this.boundYgIncreaseBtn = null;

        this._bindQuantityElements();
        this._bindVariantElements();

        if (!this.quantityInput || !this.ygNumber) {
          console.warn('YG Quantity Sync: 未找到数量元素');
          return;
        }

        // 初次同步
        this.sync();

        // MutationObserver 监听 Shopify input 的 value 变化
      }

      // 数字同步函数
      sync() {
        this.ygNumber.textContent = this.quantityInput.value;
      }

      connectedCallback() {
        this.tabEl = this;
        this.addToCartEl = this._findAddToCart();
        this.pageBottomOffset = 120; // px from bottom to hide

        this._bindProxyButton();
        this._ensureBinding();
        this._updateVisibility();

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });

        // 监听 DOM 变化（变体切换可能会替换按钮）
        this.mutationObserver = new MutationObserver(() => {
          this._ensureBinding();
          this._updateVisibility();
        });
        this.mutationObserver.observe(document.body, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        this.quantityObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.variantObserver?.disconnect();
        this._cleanupVariantBindings();
      }

      _findAddToCart() {
        for (const sel of this.addToCartTargets) {
          const el = document.querySelector(sel);
          if (el) return el;
        }
        return null;
      }

  _bindProxyButton() {
    this.proxyButton = this.querySelector('.yg-product-buy-button');
    if (!this.proxyButton) return;

    this.proxyButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (!this.addToCartEl) return;
      this.proxyButton.classList.add('loading');
      // 触发原页面加购按钮
      this.addToCartEl.click();
      // 简单的 loading 状态复位
      setTimeout(() => {
        this.proxyButton.classList.remove('loading');
      }, 1500);
    });
  }

      _ensureBinding() {
        const newBtn = this._findAddToCart();

        // 变体或 DOM 变动时，数量相关元素重绑定
        this._bindQuantityElements();
        this._bindVariantElements();

        if (newBtn !== this.addToCartEl) {
          this.visibilityObserver?.disconnect();
          this.addToCartEl = newBtn;
          if (this.addToCartEl) {
            this._observe();
          }
        }

        // 没有按钮时保持显示
        if (!this.addToCartEl) {
          this._show();
        }

        this._updateVisibility();
      }

      _observe() {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          // 当加购按钮可见时隐藏，反之显示
          if (entry.isIntersecting) {
            this._hide();
          } else {
            this._showIfNotAtBottom();
          }
        }, {
          threshold: 0.01,
        });
        this.visibilityObserver.observe(this.addToCartEl);

        // 初次绑定立即刷新状态
        this._updateVisibility();
      }

      _bindQuantityElements() {
        const newQuantityInput = document.querySelector('.product .quantity-selector__input');
        const newDecreaseBtn = document.querySelector('.product [aria-label="Decrease quantity"]');
        const newIncreaseBtn = document.querySelector('.product [aria-label="Increase quantity"]');

        // 如果输入框更换，清理旧监听与观察者
        if (newQuantityInput !== this.quantityInput) {
          this.quantityObserver?.disconnect();
          if (this.quantityInput) {
            this.quantityInput.removeEventListener('input', this.handleQuantityChange);
            this.quantityInput.removeEventListener('change', this.handleQuantityChange);
          }
          this.quantityInput = newQuantityInput;

          if (this.quantityInput) {
            this.quantityObserver = new MutationObserver(() => this.sync());
            this.quantityObserver.observe(this.quantityInput, {
              attributes: true,
              attributeFilter: ['value'],
            });
            this.quantityInput.addEventListener('input', this.handleQuantityChange);
            this.quantityInput.addEventListener('change', this.handleQuantityChange);
            this.sync();
          }
        }

        // 重绑定 +/- 触发器
        if (this.boundYgDecreaseBtn) {
          this.boundYgDecreaseBtn.removeEventListener('click', this.handleYgDecreaseClick);
          this.boundYgDecreaseBtn = null;
        }
        if (this.boundYgIncreaseBtn) {
          this.boundYgIncreaseBtn.removeEventListener('click', this.handleYgIncreaseClick);
          this.boundYgIncreaseBtn = null;
        }

        this.decreaseBtn = newDecreaseBtn;
        this.increaseBtn = newIncreaseBtn;

        if (this.ygDecreaseBtn && this.decreaseBtn) {
          this.ygDecreaseBtn.addEventListener('click', this.handleYgDecreaseClick);
          this.boundYgDecreaseBtn = this.ygDecreaseBtn;
        }

        if (this.ygIncreaseBtn && this.increaseBtn) {
          this.ygIncreaseBtn.addEventListener('click', this.handleYgIncreaseClick);
          this.boundYgIncreaseBtn = this.ygIncreaseBtn;
        }
      }

      _bindVariantElements() {
        // 监听产品主体变体区域，一旦 DOM 发生替换，重新绑定
        const productForm = document.querySelector('.product form') || document.querySelector('.product');
        if (productForm && !this.variantObserver) {
          this.variantObserver = new MutationObserver(() => {
            // 轻量重绑，确保新 DOM 接入
            this._bindVariantElements();
          });
          this.variantObserver.observe(productForm, { childList: true, subtree: true });
        }

        this.variantSelects = Array.from(this.querySelectorAll('.yg-variant-select'));

        // 解除旧监听
        this._cleanupVariantBindings();

        // 绑定自定义 select 改变 -> 驱动主体
        this.variantSelects.forEach((select) => {
          select.addEventListener('change', this.handleVariantSelectChange);
        });

        // 找到产品主体中的变体输入（select 或 radio）
        const optionSelectors = [
          '.product form [name^="options["]',
          '.product form [name^="option"]',
          '.product [name^="options["]',
          '.product [name^="option"]',
          '.product [data-option-position]', // Dawn variant-picker inputs
        ].join(',');
        this.variantInputs = Array.from(document.querySelectorAll(optionSelectors));
        this.variantInputsByIndex = {};
        this.variantInputs.forEach((input, idx) => {
          const optIndex = this._getOptionIndexFromInput(input, idx);
          if (!this.variantInputsByIndex[optIndex]) {
            this.variantInputsByIndex[optIndex] = [];
          }
          this.variantInputsByIndex[optIndex].push(input);
          input.addEventListener('change', this.handleMainVariantChange);
        });

        // 初次同步：主体 -> 自定义
        this._syncFromMain();
      }

      _cleanupVariantBindings() {
        this.variantSelects?.forEach((select) => {
          select.removeEventListener('change', this.handleVariantSelectChange);
        });
        this.variantInputs?.forEach((input) => {
          input.removeEventListener('change', this.handleMainVariantChange);
        });
      }

      _getOptionKeyFromInput(input) {
        const name = input.getAttribute('name') || '';
        const match = name.match(/\[(.+?)\]/);
        if (match && match[1]) return match[1];
        return name.replace(/^option\d+/i, '').trim() || name;
      }

      _getOptionIndexFromInput(input, fallbackIndex = 0) {
        const optionPosition = input.dataset.optionPosition;
        if (optionPosition && !Number.isNaN(Number(optionPosition))) return Number(optionPosition) - 1;
        const datasetIndex = input.dataset.index || input.getAttribute('data-index');
        if (datasetIndex && !Number.isNaN(Number(datasetIndex))) return Number(datasetIndex);
        const name = input.getAttribute('name') || '';
        const bracketNum = name.match(/\[(\d+)\]/);
        if (bracketNum && bracketNum[1]) return Number(bracketNum[1]);
        const optionNum = name.match(/option-?(\d+)/i);
        if (optionNum && optionNum[1]) return Number(optionNum[1]);
        return fallbackIndex;
      }

      _getLabelTextForInput(input) {
        const dataLabel = input.dataset.optionLabel;
        if (dataLabel) return dataLabel;
        const id = input.id;
        const labelByFor = id ? document.querySelector(`label[for="${id}"]`) : null;
        const labelEl = input.closest('label') || labelByFor;
        if (labelEl) return labelEl.textContent.trim();
        return input.value;
      }

      _getMainOptionValues() {
        const values = {};
        Object.entries(this.variantInputsByIndex).forEach(([idx, inputs]) => {
          inputs.forEach((input) => {
            if (input.type === 'radio') {
              if (input.checked) {
                values[idx] = this._getLabelTextForInput(input);
              }
            } else {
              values[idx] = input.value;
            }
          });
        });
        return values;
      }

      _syncFromMain() {
        const values = this._getMainOptionValues();
        this.variantSelects.forEach((select) => {
          const idx = select.dataset.optionIndex;
          if (idx === undefined) return;
          if (!(idx in values)) return;
          if (select.value !== values[idx]) {
            select.value = values[idx];
          }
        });
      }

      _syncToMain(optionIndex, value) {
        const inputs = this.variantInputsByIndex[optionIndex] || [];
        inputs.forEach((input) => {
          const labelValue = this._getLabelTextForInput(input);
          if (input.type === 'radio') {
            if (labelValue === value || input.value === value) {
              if (!input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          } else {
            if (input.value !== value) {
              input.value = value;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        });
      }

      _onVariantSelectChange(event) {
        const select = event.target;
        const optionIndex = Number(select.dataset.optionIndex);
        if (Number.isNaN(optionIndex)) return;
        this._syncToMain(optionIndex, select.value);
      }

      _onMainVariantChange() {
        this._syncFromMain();
      }

      _onScroll() {
        // 确保在变体切换后仍有正确的按钮绑定
        this._ensureBinding();

        // 滚动到底部附近时隐藏
        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        // 如果不在底部，再根据加购可见性决定
        this._updateVisibility();
      }

      _isElementInViewport(el) {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return (
          rect.top < window.innerHeight &&
          rect.bottom > 0 &&
          rect.left < window.innerWidth &&
          rect.right > 0
        );
      }

      _hasScrolledToProductButton() {
        if (!this.addToCartEl) return true; // 如果没有按钮，认为已经滚动到
        const buttonRect = this.addToCartEl.getBoundingClientRect();
        const buttonTop = buttonRect.top + window.scrollY;
        // 检查是否已经滚动到按钮位置（按钮顶部已经在视口上方或可见）
        return window.scrollY >= buttonTop - window.innerHeight;
      }

      _showIfNotAtBottom() {
        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        this._show();
      }

      _updateVisibility() {
        if (!this.addToCartEl) {
          this._show();
          return;
        }

        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        if (this._isElementInViewport(this.addToCartEl)) {
          this._hide();
        } else {
          this._show();
        }
      }

      _show() {
        this.tabEl.style.opacity = '1';
        this.tabEl.style.pointerEvents = 'auto';
      }

      _hide() {
        this.tabEl.style.opacity = '0';
        this.tabEl.style.pointerEvents = 'none';
      }
    }

    // 自定义 select 组件 - 完美继承原生 select 功能
    class YgCustomSelect extends HTMLElement {
      constructor() {
        super();
        this._value = '';
        this._options = [];
        this._selectedIndex = -1;
        this._isOpen = false;
      }

      static get observedAttributes() {
        return ['data-option-index', 'data-option-name'];
      }

      connectedCallback() {
        this._initOptions();
        this._render();
        this._attachEvents();
        this._updateSelectedDisplay();
        // 根据最长选项文本设置最小宽度
        try {
          this._setMinWidth();
        } catch (e) {
          // 忽略测量错误，避免阻断渲染
          console.error('yg-custom-select setMinWidth error', e);
        }
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-option-index' || name === 'data-option-name') {
          // 属性变化时不需要特殊处理，因为逻辑通过 value 控制
        }
      }

      _initOptions() {
        const optionElements = this.querySelectorAll('.yg-custom-select-option');
        this._options = Array.from(optionElements).map((opt, index) => {
          const value = opt.dataset.value || opt.textContent.trim();
          const isSelected = opt.dataset.selected === 'true' || opt.hasAttribute('data-selected');
          return {
            value: value,
            text: opt.textContent.trim(),
            element: opt,
            index: index
          };
        });

        // 找到初始选中项
        const selectedOption = this._options.find((opt, idx) => {
          const el = opt.element;
          return el.dataset.selected === 'true' || el.hasAttribute('data-selected');
        });

        if (selectedOption) {
          this._selectedIndex = selectedOption.index;
          this._value = selectedOption.value;
        } else if (this._options.length > 0) {
          this._selectedIndex = 0;
          this._value = this._options[0].value;
        }
      }

      _render() {
        // 检查是否已经渲染过
        if (this._trigger) return;

        const trigger = document.createElement('button');
        trigger.className = 'yg-custom-select-trigger';
        trigger.type = 'button';
        trigger.setAttribute('aria-haspopup', 'listbox');

        const text = document.createElement('span');
        text.className = 'yg-custom-select-text';
        trigger.appendChild(text);

        const arrow = document.createElement('span');
        arrow.className = 'yg-custom-select-arrow';
        arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M4 6L8 10L12 6" stroke="#4B4C4D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        trigger.appendChild(arrow);

        const dropdown = document.createElement('div');
        dropdown.className = 'yg-custom-select-dropdown';
        dropdown.setAttribute('role', 'listbox');
        dropdown.hidden = true;

        // 将现有选项元素移动到 dropdown
        this._options.forEach((opt) => {
          opt.element.setAttribute('role', 'option');
          if (opt.index === this._selectedIndex) {
            opt.element.classList.add('selected');
          }
          dropdown.appendChild(opt.element);
        });

        this._trigger = trigger;
        this._text = text;
        this._dropdown = dropdown;

        this.appendChild(trigger);
        this.appendChild(dropdown);
      }

      _setMinWidth() {
        if (!this._options || this._options.length === 0) return;
        if (!this._trigger) return;

        // 使用 canvas 精确测量文字宽度，避免 clone 带来的样式差异
        const textEl = this._trigger.querySelector('.yg-custom-select-text') || this._trigger;
        const textStyle = window.getComputedStyle(textEl);
        const triggerStyle = window.getComputedStyle(this._trigger);

        const font = textStyle.font || `${textStyle.fontStyle} ${textStyle.fontWeight} ${textStyle.fontSize} ${textStyle.fontFamily}`;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.font = font;

        let maxTextWidth = 0;
        this._options.forEach((opt) => {
          const measured = Math.ceil(ctx.measureText(opt.text).width);
          if (measured > maxTextWidth) maxTextWidth = measured;
        });

        // 计算额外宽度：左右内边距、边框、箭头宽度、gap 等
        const paddingLeft = parseFloat(triggerStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(triggerStyle.paddingRight) || 0;
        const borderLeft = parseFloat(triggerStyle.borderLeftWidth) || 0;
        const borderRight = parseFloat(triggerStyle.borderRightWidth) || 0;
        const gap = parseFloat(triggerStyle.gap) || 8;
        // 箭头元素宽度（尝试测量实际元素）
        const arrowEl = this._trigger.querySelector('.yg-custom-select-arrow');
        let arrowWidth = 0;
        if (arrowEl) {
          const arrowStyle = window.getComputedStyle(arrowEl);
          arrowWidth = parseFloat(arrowStyle.width) || arrowEl.getBoundingClientRect().width || 0;
        } else {
          arrowWidth = 12;
        }

        const total = maxTextWidth + paddingLeft + paddingRight + borderLeft + borderRight + arrowWidth + gap + 2; // +2 作为容错
        this._trigger.style.minWidth = Math.ceil(total) + 'px';
      }

      _attachEvents() {
        // 点击触发按钮
        this._trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle();
        });

        // 点击选项
        this._options.forEach((opt) => {
          opt.element.addEventListener('click', (e) => {
            e.stopPropagation();
            this._selectOption(opt.index);
            this.close();
          });
        });

        // 点击外部关闭
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) {
            this.close();
          }
        });
      }

      _selectOption(index) {
        if (index < 0 || index >= this._options.length) return;
        if (this._selectedIndex === index) return;

        const oldValue = this._value;
        this._selectedIndex = index;
        this._value = this._options[index].value;

        // 更新选中状态
        this._options.forEach((opt, idx) => {
          if (idx === index) {
            opt.element.classList.add('selected');
            opt.element.setAttribute('data-selected', 'true');
          } else {
            opt.element.classList.remove('selected');
            opt.element.removeAttribute('data-selected');
          }
        });

        this._updateSelectedDisplay();

        // 触发 change 事件（兼容原生 select 行为）
        if (oldValue !== this._value) {
          this.dispatchEvent(new Event('change', { bubbles: true }));
          this.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      _updateSelectedDisplay() {
        if (this._selectedIndex >= 0 && this._selectedIndex < this._options.length) {
          this._text.textContent = this._options[this._selectedIndex].text;
        }
      }

      toggle() {
        if (this._isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        // 关闭其他 select
        document.querySelectorAll('yg-custom-select').forEach((select) => {
          if (select !== this) {
            select.close();
          }
        });

        this._isOpen = true;
        this.classList.add('open');
        this._dropdown.hidden = false;
      }

      close() {
        this._isOpen = false;
        this.classList.remove('open');
        this._dropdown.hidden = true;
      }

      // 实现原生 select 的 value 属性
      get value() {
        return this._value;
      }

      set value(newValue) {
        const index = this._options.findIndex((opt) => opt.value === newValue);
        if (index >= 0) {
          this._selectOption(index);
        }
      }

      // 实现原生 select 的 options 属性（类数组对象）
      get options() {
        const self = this;
        const optionsArray = this._options.map((opt, idx) => ({
          value: opt.value,
          text: opt.text,
          selected: idx === this._selectedIndex,
          index: idx
        }));

        // 创建类数组对象，支持 Array.from() 和 forEach 等
        const optionsObj = Object.create(Array.prototype);
        optionsArray.forEach((opt, idx) => {
          optionsObj[idx] = opt;
        });
        optionsObj.length = optionsArray.length;

        // 添加常用方法
        optionsObj.item = function(index) {
          return this[index] || null;
        };
        optionsObj.forEach = Array.prototype.forEach.bind(optionsArray);
        optionsObj.find = Array.prototype.find.bind(optionsArray);
        optionsObj.filter = Array.prototype.filter.bind(optionsArray);
        optionsObj.map = Array.prototype.map.bind(optionsArray);

        return optionsObj;
      }
    }

    if (!customElements.get('yg-custom-select')) {
      customElements.define('yg-custom-select', YgCustomSelect);
    }

    if (!customElements.get('yg-product-tab')) {
      customElements.define('yg-product-tab', YGProductTab);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class YGProductTab extends HTMLElement {
      constructor() {
        super();
        this._onScroll = this._onScroll.bind(this);
        this._observe = this._observe.bind(this);
        this.handleQuantityChange = this.sync.bind(this);
        this.handleYgDecreaseClick = () => { this.decreaseBtn?.click(); };
        this.handleYgIncreaseClick = () => { this.increaseBtn?.click(); };
        this.handleVariantSelectChange = this._onVariantSelectChange.bind(this);
        this.handleMainVariantChange = this._onMainVariantChange.bind(this);
        this.addToCartTargets = [
          '.product-info__buy-buttons .button[type="submit"]',
          'button[name="add"]',
          '#AddToCart',
          '.product-form__submit',
        ];
        this.proxyButton = null;
        this.mutationObserver = null;
        this.quantityObserver = null;
        this.visibilityObserver = null;
        this.variantObserver = null;
        this.variantInputs = [];
        this.variantInputsByIndex = {};
        this.variantSelects = [];
        this._updateVisibility = this._updateVisibility.bind(this);
        this.ygNumber = this.querySelector('.yg-product-number');
        this.ygDecreaseBtn = this.querySelector('.yg-number-decrease');
        this.ygIncreaseBtn = this.querySelector('.yg-number-increase');
        this.ygVariantSelectsContainer = this.querySelector('.yg-variant-selects');

        // Shopify 元素
        this.quantityInput = null;
        this.decreaseBtn = null;
        this.increaseBtn = null;
        this.boundYgDecreaseBtn = null;
        this.boundYgIncreaseBtn = null;

        this._bindQuantityElements();
        this._bindVariantElements();

        if (!this.quantityInput || !this.ygNumber) {
          console.warn('YG Quantity Sync: 未找到数量元素');
          return;
        }

        // 初次同步
        this.sync();

        // MutationObserver 监听 Shopify input 的 value 变化
      }

      // 数字同步函数
      sync() {
        this.ygNumber.textContent = this.quantityInput.value;
      }

      connectedCallback() {
        this.tabEl = this;
        this.addToCartEl = this._findAddToCart();
        this.pageBottomOffset = 120; // px from bottom to hide

        this._bindProxyButton();
        this._ensureBinding();
        this._updateVisibility();

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });

        // 监听 DOM 变化（变体切换可能会替换按钮）
        this.mutationObserver = new MutationObserver(() => {
          this._ensureBinding();
          this._updateVisibility();
        });
        this.mutationObserver.observe(document.body, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        this.quantityObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.variantObserver?.disconnect();
        this._cleanupVariantBindings();
      }

      _findAddToCart() {
        for (const sel of this.addToCartTargets) {
          const el = document.querySelector(sel);
          if (el) return el;
        }
        return null;
      }

  _bindProxyButton() {
    this.proxyButton = this.querySelector('.yg-product-buy-button');
    if (!this.proxyButton) return;

    this.proxyButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (!this.addToCartEl) return;
      this.proxyButton.classList.add('loading');
      // 触发原页面加购按钮
      this.addToCartEl.click();
      // 简单的 loading 状态复位
      setTimeout(() => {
        this.proxyButton.classList.remove('loading');
      }, 1500);
    });
  }

      _ensureBinding() {
        const newBtn = this._findAddToCart();

        // 变体或 DOM 变动时，数量相关元素重绑定
        this._bindQuantityElements();
        this._bindVariantElements();

        if (newBtn !== this.addToCartEl) {
          this.visibilityObserver?.disconnect();
          this.addToCartEl = newBtn;
          if (this.addToCartEl) {
            this._observe();
          }
        }

        // 没有按钮时保持显示
        if (!this.addToCartEl) {
          this._show();
        }

        this._updateVisibility();
      }

      _observe() {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          // 当加购按钮可见时隐藏，反之显示
          if (entry.isIntersecting) {
            this._hide();
          } else {
            this._showIfNotAtBottom();
          }
        }, {
          threshold: 0.01,
        });
        this.visibilityObserver.observe(this.addToCartEl);

        // 初次绑定立即刷新状态
        this._updateVisibility();
      }

      _bindQuantityElements() {
        const newQuantityInput = document.querySelector('.product .quantity-selector__input');
        const newDecreaseBtn = document.querySelector('.product [aria-label="Decrease quantity"]');
        const newIncreaseBtn = document.querySelector('.product [aria-label="Increase quantity"]');

        // 如果输入框更换，清理旧监听与观察者
        if (newQuantityInput !== this.quantityInput) {
          this.quantityObserver?.disconnect();
          if (this.quantityInput) {
            this.quantityInput.removeEventListener('input', this.handleQuantityChange);
            this.quantityInput.removeEventListener('change', this.handleQuantityChange);
          }
          this.quantityInput = newQuantityInput;

          if (this.quantityInput) {
            this.quantityObserver = new MutationObserver(() => this.sync());
            this.quantityObserver.observe(this.quantityInput, {
              attributes: true,
              attributeFilter: ['value'],
            });
            this.quantityInput.addEventListener('input', this.handleQuantityChange);
            this.quantityInput.addEventListener('change', this.handleQuantityChange);
            this.sync();
          }
        }

        // 重绑定 +/- 触发器
        if (this.boundYgDecreaseBtn) {
          this.boundYgDecreaseBtn.removeEventListener('click', this.handleYgDecreaseClick);
          this.boundYgDecreaseBtn = null;
        }
        if (this.boundYgIncreaseBtn) {
          this.boundYgIncreaseBtn.removeEventListener('click', this.handleYgIncreaseClick);
          this.boundYgIncreaseBtn = null;
        }

        this.decreaseBtn = newDecreaseBtn;
        this.increaseBtn = newIncreaseBtn;

        if (this.ygDecreaseBtn && this.decreaseBtn) {
          this.ygDecreaseBtn.addEventListener('click', this.handleYgDecreaseClick);
          this.boundYgDecreaseBtn = this.ygDecreaseBtn;
        }

        if (this.ygIncreaseBtn && this.increaseBtn) {
          this.ygIncreaseBtn.addEventListener('click', this.handleYgIncreaseClick);
          this.boundYgIncreaseBtn = this.ygIncreaseBtn;
        }
      }

      _bindVariantElements() {
        // 监听产品主体变体区域，一旦 DOM 发生替换，重新绑定
        const productForm = document.querySelector('.product form') || document.querySelector('.product');
        if (productForm && !this.variantObserver) {
          this.variantObserver = new MutationObserver(() => {
            // 轻量重绑，确保新 DOM 接入
            this._bindVariantElements();
          });
          this.variantObserver.observe(productForm, { childList: true, subtree: true });
        }

        this.variantSelects = Array.from(this.querySelectorAll('.yg-variant-select'));

        // 解除旧监听
        this._cleanupVariantBindings();

        // 绑定自定义 select 改变 -> 驱动主体
        this.variantSelects.forEach((select) => {
          select.addEventListener('change', this.handleVariantSelectChange);
        });

        // 找到产品主体中的变体输入（select 或 radio）
        const optionSelectors = [
          '.product form [name^="options["]',
          '.product form [name^="option"]',
          '.product [name^="options["]',
          '.product [name^="option"]',
          '.product [data-option-position]', // Dawn variant-picker inputs
        ].join(',');
        this.variantInputs = Array.from(document.querySelectorAll(optionSelectors));
        this.variantInputsByIndex = {};
        this.variantInputs.forEach((input, idx) => {
          const optIndex = this._getOptionIndexFromInput(input, idx);
          if (!this.variantInputsByIndex[optIndex]) {
            this.variantInputsByIndex[optIndex] = [];
          }
          this.variantInputsByIndex[optIndex].push(input);
          input.addEventListener('change', this.handleMainVariantChange);
        });

        // 初次同步：主体 -> 自定义
        this._syncFromMain();
      }

      _cleanupVariantBindings() {
        this.variantSelects?.forEach((select) => {
          select.removeEventListener('change', this.handleVariantSelectChange);
        });
        this.variantInputs?.forEach((input) => {
          input.removeEventListener('change', this.handleMainVariantChange);
        });
      }

      _getOptionKeyFromInput(input) {
        const name = input.getAttribute('name') || '';
        const match = name.match(/\[(.+?)\]/);
        if (match && match[1]) return match[1];
        return name.replace(/^option\d+/i, '').trim() || name;
      }

      _getOptionIndexFromInput(input, fallbackIndex = 0) {
        const optionPosition = input.dataset.optionPosition;
        if (optionPosition && !Number.isNaN(Number(optionPosition))) return Number(optionPosition) - 1;
        const datasetIndex = input.dataset.index || input.getAttribute('data-index');
        if (datasetIndex && !Number.isNaN(Number(datasetIndex))) return Number(datasetIndex);
        const name = input.getAttribute('name') || '';
        const bracketNum = name.match(/\[(\d+)\]/);
        if (bracketNum && bracketNum[1]) return Number(bracketNum[1]);
        const optionNum = name.match(/option-?(\d+)/i);
        if (optionNum && optionNum[1]) return Number(optionNum[1]);
        return fallbackIndex;
      }

      _getLabelTextForInput(input) {
        const dataLabel = input.dataset.optionLabel;
        if (dataLabel) return dataLabel;
        const id = input.id;
        const labelByFor = id ? document.querySelector(`label[for="${id}"]`) : null;
        const labelEl = input.closest('label') || labelByFor;
        if (labelEl) return labelEl.textContent.trim();
        return input.value;
      }

      _getMainOptionValues() {
        const values = {};
        Object.entries(this.variantInputsByIndex).forEach(([idx, inputs]) => {
          inputs.forEach((input) => {
            if (input.type === 'radio') {
              if (input.checked) {
                values[idx] = this._getLabelTextForInput(input);
              }
            } else {
              values[idx] = input.value;
            }
          });
        });
        return values;
      }

      _syncFromMain() {
        const values = this._getMainOptionValues();
        this.variantSelects.forEach((select) => {
          const idx = select.dataset.optionIndex;
          if (idx === undefined) return;
          if (!(idx in values)) return;
          if (select.value !== values[idx]) {
            select.value = values[idx];
          }
        });
      }

      _syncToMain(optionIndex, value) {
        const inputs = this.variantInputsByIndex[optionIndex] || [];
        inputs.forEach((input) => {
          const labelValue = this._getLabelTextForInput(input);
          if (input.type === 'radio') {
            if (labelValue === value || input.value === value) {
              if (!input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          } else {
            if (input.value !== value) {
              input.value = value;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        });
      }

      _onVariantSelectChange(event) {
        const select = event.target;
        const optionIndex = Number(select.dataset.optionIndex);
        if (Number.isNaN(optionIndex)) return;
        this._syncToMain(optionIndex, select.value);
      }

      _onMainVariantChange() {
        this._syncFromMain();
      }

      _onScroll() {
        // 确保在变体切换后仍有正确的按钮绑定
        this._ensureBinding();

        // 滚动到底部附近时隐藏
        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        // 如果不在底部，再根据加购可见性决定
        this._updateVisibility();
      }

      _isElementInViewport(el) {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return (
          rect.top < window.innerHeight &&
          rect.bottom > 0 &&
          rect.left < window.innerWidth &&
          rect.right > 0
        );
      }

      _hasScrolledToProductButton() {
        if (!this.addToCartEl) return true; // 如果没有按钮，认为已经滚动到
        const buttonRect = this.addToCartEl.getBoundingClientRect();
        const buttonTop = buttonRect.top + window.scrollY;
        // 检查是否已经滚动到按钮位置（按钮顶部已经在视口上方或可见）
        return window.scrollY >= buttonTop - window.innerHeight;
      }

      _showIfNotAtBottom() {
        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        this._show();
      }

      _updateVisibility() {
        if (!this.addToCartEl) {
          this._show();
          return;
        }

        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        if (this._isElementInViewport(this.addToCartEl)) {
          this._hide();
        } else {
          this._show();
        }
      }

      _show() {
        this.tabEl.style.opacity = '1';
        this.tabEl.style.pointerEvents = 'auto';
      }

      _hide() {
        this.tabEl.style.opacity = '0';
        this.tabEl.style.pointerEvents = 'none';
      }
    }

    // 自定义 select 组件 - 完美继承原生 select 功能
    class YgCustomSelect extends HTMLElement {
      constructor() {
        super();
        this._value = '';
        this._options = [];
        this._selectedIndex = -1;
        this._isOpen = false;
      }

      static get observedAttributes() {
        return ['data-option-index', 'data-option-name'];
      }

      connectedCallback() {
        this._initOptions();
        this._render();
        this._attachEvents();
        this._updateSelectedDisplay();
        // 根据最长选项文本设置最小宽度
        try {
          this._setMinWidth();
        } catch (e) {
          // 忽略测量错误，避免阻断渲染
          console.error('yg-custom-select setMinWidth error', e);
        }
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-option-index' || name === 'data-option-name') {
          // 属性变化时不需要特殊处理，因为逻辑通过 value 控制
        }
      }

      _initOptions() {
        const optionElements = this.querySelectorAll('.yg-custom-select-option');
        this._options = Array.from(optionElements).map((opt, index) => {
          const value = opt.dataset.value || opt.textContent.trim();
          const isSelected = opt.dataset.selected === 'true' || opt.hasAttribute('data-selected');
          return {
            value: value,
            text: opt.textContent.trim(),
            element: opt,
            index: index
          };
        });

        // 找到初始选中项
        const selectedOption = this._options.find((opt, idx) => {
          const el = opt.element;
          return el.dataset.selected === 'true' || el.hasAttribute('data-selected');
        });

        if (selectedOption) {
          this._selectedIndex = selectedOption.index;
          this._value = selectedOption.value;
        } else if (this._options.length > 0) {
          this._selectedIndex = 0;
          this._value = this._options[0].value;
        }
      }

      _render() {
        // 检查是否已经渲染过
        if (this._trigger) return;

        const trigger = document.createElement('button');
        trigger.className = 'yg-custom-select-trigger';
        trigger.type = 'button';
        trigger.setAttribute('aria-haspopup', 'listbox');

        const text = document.createElement('span');
        text.className = 'yg-custom-select-text';
        trigger.appendChild(text);

        const arrow = document.createElement('span');
        arrow.className = 'yg-custom-select-arrow';
        arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M4 6L8 10L12 6" stroke="#4B4C4D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        trigger.appendChild(arrow);

        const dropdown = document.createElement('div');
        dropdown.className = 'yg-custom-select-dropdown';
        dropdown.setAttribute('role', 'listbox');
        dropdown.hidden = true;

        // 将现有选项元素移动到 dropdown
        this._options.forEach((opt) => {
          opt.element.setAttribute('role', 'option');
          if (opt.index === this._selectedIndex) {
            opt.element.classList.add('selected');
          }
          dropdown.appendChild(opt.element);
        });

        this._trigger = trigger;
        this._text = text;
        this._dropdown = dropdown;

        this.appendChild(trigger);
        this.appendChild(dropdown);
      }

      _setMinWidth() {
        if (!this._options || this._options.length === 0) return;
        if (!this._trigger) return;

        // 使用 canvas 精确测量文字宽度，避免 clone 带来的样式差异
        const textEl = this._trigger.querySelector('.yg-custom-select-text') || this._trigger;
        const textStyle = window.getComputedStyle(textEl);
        const triggerStyle = window.getComputedStyle(this._trigger);

        const font = textStyle.font || `${textStyle.fontStyle} ${textStyle.fontWeight} ${textStyle.fontSize} ${textStyle.fontFamily}`;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.font = font;

        let maxTextWidth = 0;
        this._options.forEach((opt) => {
          const measured = Math.ceil(ctx.measureText(opt.text).width);
          if (measured > maxTextWidth) maxTextWidth = measured;
        });

        // 计算额外宽度：左右内边距、边框、箭头宽度、gap 等
        const paddingLeft = parseFloat(triggerStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(triggerStyle.paddingRight) || 0;
        const borderLeft = parseFloat(triggerStyle.borderLeftWidth) || 0;
        const borderRight = parseFloat(triggerStyle.borderRightWidth) || 0;
        const gap = parseFloat(triggerStyle.gap) || 8;
        // 箭头元素宽度（尝试测量实际元素）
        const arrowEl = this._trigger.querySelector('.yg-custom-select-arrow');
        let arrowWidth = 0;
        if (arrowEl) {
          const arrowStyle = window.getComputedStyle(arrowEl);
          arrowWidth = parseFloat(arrowStyle.width) || arrowEl.getBoundingClientRect().width || 0;
        } else {
          arrowWidth = 12;
        }

        const total = maxTextWidth + paddingLeft + paddingRight + borderLeft + borderRight + arrowWidth + gap + 2; // +2 作为容错
        this._trigger.style.minWidth = Math.ceil(total) + 'px';
      }

      _attachEvents() {
        // 点击触发按钮
        this._trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle();
        });

        // 点击选项
        this._options.forEach((opt) => {
          opt.element.addEventListener('click', (e) => {
            e.stopPropagation();
            this._selectOption(opt.index);
            this.close();
          });
        });

        // 点击外部关闭
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) {
            this.close();
          }
        });
      }

      _selectOption(index) {
        if (index < 0 || index >= this._options.length) return;
        if (this._selectedIndex === index) return;

        const oldValue = this._value;
        this._selectedIndex = index;
        this._value = this._options[index].value;

        // 更新选中状态
        this._options.forEach((opt, idx) => {
          if (idx === index) {
            opt.element.classList.add('selected');
            opt.element.setAttribute('data-selected', 'true');
          } else {
            opt.element.classList.remove('selected');
            opt.element.removeAttribute('data-selected');
          }
        });

        this._updateSelectedDisplay();

        // 触发 change 事件（兼容原生 select 行为）
        if (oldValue !== this._value) {
          this.dispatchEvent(new Event('change', { bubbles: true }));
          this.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      _updateSelectedDisplay() {
        if (this._selectedIndex >= 0 && this._selectedIndex < this._options.length) {
          this._text.textContent = this._options[this._selectedIndex].text;
        }
      }

      toggle() {
        if (this._isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        // 关闭其他 select
        document.querySelectorAll('yg-custom-select').forEach((select) => {
          if (select !== this) {
            select.close();
          }
        });

        this._isOpen = true;
        this.classList.add('open');
        this._dropdown.hidden = false;
      }

      close() {
        this._isOpen = false;
        this.classList.remove('open');
        this._dropdown.hidden = true;
      }

      // 实现原生 select 的 value 属性
      get value() {
        return this._value;
      }

      set value(newValue) {
        const index = this._options.findIndex((opt) => opt.value === newValue);
        if (index >= 0) {
          this._selectOption(index);
        }
      }

      // 实现原生 select 的 options 属性（类数组对象）
      get options() {
        const self = this;
        const optionsArray = this._options.map((opt, idx) => ({
          value: opt.value,
          text: opt.text,
          selected: idx === this._selectedIndex,
          index: idx
        }));

        // 创建类数组对象，支持 Array.from() 和 forEach 等
        const optionsObj = Object.create(Array.prototype);
        optionsArray.forEach((opt, idx) => {
          optionsObj[idx] = opt;
        });
        optionsObj.length = optionsArray.length;

        // 添加常用方法
        optionsObj.item = function(index) {
          return this[index] || null;
        };
        optionsObj.forEach = Array.prototype.forEach.bind(optionsArray);
        optionsObj.find = Array.prototype.find.bind(optionsArray);
        optionsObj.filter = Array.prototype.filter.bind(optionsArray);
        optionsObj.map = Array.prototype.map.bind(optionsArray);

        return optionsObj;
      }
    }

    if (!customElements.get('yg-custom-select')) {
      customElements.define('yg-custom-select', YgCustomSelect);
    }

    if (!customElements.get('yg-product-tab')) {
      customElements.define('yg-product-tab', YGProductTab);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-tab22"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class YGProductTab extends HTMLElement {
      constructor() {
        super();
        this._onScroll = this._onScroll.bind(this);
        this._observe = this._observe.bind(this);
        this.handleQuantityChange = this.sync.bind(this);
        this.handleYgDecreaseClick = () => { this.decreaseBtn?.click(); };
        this.handleYgIncreaseClick = () => { this.increaseBtn?.click(); };
        this.handleVariantSelectChange = this._onVariantSelectChange.bind(this);
        this.handleMainVariantChange = this._onMainVariantChange.bind(this);
        this.addToCartTargets = [
          '.product-info__buy-buttons .button[type="submit"]',
          'button[name="add"]',
          '#AddToCart',
          '.product-form__submit',
        ];
        this.proxyButton = null;
        this.mutationObserver = null;
        this.quantityObserver = null;
        this.visibilityObserver = null;
        this.variantObserver = null;
        this.variantInputs = [];
        this.variantInputsByIndex = {};
        this.variantSelects = [];
        this._updateVisibility = this._updateVisibility.bind(this);
        this.ygNumber = this.querySelector('.yg-product-number');
        this.ygDecreaseBtn = this.querySelector('.yg-number-decrease');
        this.ygIncreaseBtn = this.querySelector('.yg-number-increase');
        this.ygVariantSelectsContainer = this.querySelector('.yg-variant-selects');

        // Shopify 元素
        this.quantityInput = null;
        this.decreaseBtn = null;
        this.increaseBtn = null;
        this.boundYgDecreaseBtn = null;
        this.boundYgIncreaseBtn = null;

        this._bindQuantityElements();
        this._bindVariantElements();

        if (!this.quantityInput || !this.ygNumber) {
          console.warn('YG Quantity Sync: 未找到数量元素');
          return;
        }

        // 初次同步
        this.sync();

        // MutationObserver 监听 Shopify input 的 value 变化
      }

      // 数字同步函数
      sync() {
        this.ygNumber.textContent = this.quantityInput.value;
      }

      connectedCallback() {
        this.tabEl = this;
        this.addToCartEl = this._findAddToCart();
        this.pageBottomOffset = 120; // px from bottom to hide

        this._bindProxyButton();
        this._ensureBinding();
        this._updateVisibility();

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });

        // 监听 DOM 变化（变体切换可能会替换按钮）
        this.mutationObserver = new MutationObserver(() => {
          this._ensureBinding();
          this._updateVisibility();
        });
        this.mutationObserver.observe(document.body, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        this.quantityObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.variantObserver?.disconnect();
        this._cleanupVariantBindings();
      }

      _findAddToCart() {
        for (const sel of this.addToCartTargets) {
          const el = document.querySelector(sel);
          if (el) return el;
        }
        return null;
      }

  _bindProxyButton() {
    this.proxyButton = this.querySelector('.yg-product-buy-button');
    if (!this.proxyButton) return;

    this.proxyButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (!this.addToCartEl) return;
      this.proxyButton.classList.add('loading');
      // 触发原页面加购按钮
      this.addToCartEl.click();
      // 简单的 loading 状态复位
      setTimeout(() => {
        this.proxyButton.classList.remove('loading');
      }, 1500);
    });
  }

      _ensureBinding() {
        const newBtn = this._findAddToCart();

        // 变体或 DOM 变动时，数量相关元素重绑定
        this._bindQuantityElements();
        this._bindVariantElements();

        if (newBtn !== this.addToCartEl) {
          this.visibilityObserver?.disconnect();
          this.addToCartEl = newBtn;
          if (this.addToCartEl) {
            this._observe();
          }
        }

        // 没有按钮时保持显示
        if (!this.addToCartEl) {
          this._show();
        }

        this._updateVisibility();
      }

      _observe() {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;
          // 当加购按钮可见时隐藏，反之显示
          if (entry.isIntersecting) {
            this._hide();
          } else {
            this._showIfNotAtBottom();
          }
        }, {
          threshold: 0.01,
        });
        this.visibilityObserver.observe(this.addToCartEl);

        // 初次绑定立即刷新状态
        this._updateVisibility();
      }

      _bindQuantityElements() {
        const newQuantityInput = document.querySelector('.product .quantity-selector__input');
        const newDecreaseBtn = document.querySelector('.product [aria-label="Decrease quantity"]');
        const newIncreaseBtn = document.querySelector('.product [aria-label="Increase quantity"]');

        // 如果输入框更换，清理旧监听与观察者
        if (newQuantityInput !== this.quantityInput) {
          this.quantityObserver?.disconnect();
          if (this.quantityInput) {
            this.quantityInput.removeEventListener('input', this.handleQuantityChange);
            this.quantityInput.removeEventListener('change', this.handleQuantityChange);
          }
          this.quantityInput = newQuantityInput;

          if (this.quantityInput) {
            this.quantityObserver = new MutationObserver(() => this.sync());
            this.quantityObserver.observe(this.quantityInput, {
              attributes: true,
              attributeFilter: ['value'],
            });
            this.quantityInput.addEventListener('input', this.handleQuantityChange);
            this.quantityInput.addEventListener('change', this.handleQuantityChange);
            this.sync();
          }
        }

        // 重绑定 +/- 触发器
        if (this.boundYgDecreaseBtn) {
          this.boundYgDecreaseBtn.removeEventListener('click', this.handleYgDecreaseClick);
          this.boundYgDecreaseBtn = null;
        }
        if (this.boundYgIncreaseBtn) {
          this.boundYgIncreaseBtn.removeEventListener('click', this.handleYgIncreaseClick);
          this.boundYgIncreaseBtn = null;
        }

        this.decreaseBtn = newDecreaseBtn;
        this.increaseBtn = newIncreaseBtn;

        if (this.ygDecreaseBtn && this.decreaseBtn) {
          this.ygDecreaseBtn.addEventListener('click', this.handleYgDecreaseClick);
          this.boundYgDecreaseBtn = this.ygDecreaseBtn;
        }

        if (this.ygIncreaseBtn && this.increaseBtn) {
          this.ygIncreaseBtn.addEventListener('click', this.handleYgIncreaseClick);
          this.boundYgIncreaseBtn = this.ygIncreaseBtn;
        }
      }

      _bindVariantElements() {
        // 监听产品主体变体区域，一旦 DOM 发生替换，重新绑定
        const productForm = document.querySelector('.product form') || document.querySelector('.product');
        if (productForm && !this.variantObserver) {
          this.variantObserver = new MutationObserver(() => {
            // 轻量重绑，确保新 DOM 接入
            this._bindVariantElements();
          });
          this.variantObserver.observe(productForm, { childList: true, subtree: true });
        }

        this.variantSelects = Array.from(this.querySelectorAll('.yg-variant-select'));

        // 解除旧监听
        this._cleanupVariantBindings();

        // 绑定自定义 select 改变 -> 驱动主体
        this.variantSelects.forEach((select) => {
          select.addEventListener('change', this.handleVariantSelectChange);
        });

        // 找到产品主体中的变体输入（select 或 radio）
        const optionSelectors = [
          '.product form [name^="options["]',
          '.product form [name^="option"]',
          '.product [name^="options["]',
          '.product [name^="option"]',
          '.product [data-option-position]', // Dawn variant-picker inputs
        ].join(',');
        this.variantInputs = Array.from(document.querySelectorAll(optionSelectors));
        this.variantInputsByIndex = {};
        this.variantInputs.forEach((input, idx) => {
          const optIndex = this._getOptionIndexFromInput(input, idx);
          if (!this.variantInputsByIndex[optIndex]) {
            this.variantInputsByIndex[optIndex] = [];
          }
          this.variantInputsByIndex[optIndex].push(input);
          input.addEventListener('change', this.handleMainVariantChange);
        });

        // 初次同步：主体 -> 自定义
        this._syncFromMain();
      }

      _cleanupVariantBindings() {
        this.variantSelects?.forEach((select) => {
          select.removeEventListener('change', this.handleVariantSelectChange);
        });
        this.variantInputs?.forEach((input) => {
          input.removeEventListener('change', this.handleMainVariantChange);
        });
      }

      _getOptionKeyFromInput(input) {
        const name = input.getAttribute('name') || '';
        const match = name.match(/\[(.+?)\]/);
        if (match && match[1]) return match[1];
        return name.replace(/^option\d+/i, '').trim() || name;
      }

      _getOptionIndexFromInput(input, fallbackIndex = 0) {
        const optionPosition = input.dataset.optionPosition;
        if (optionPosition && !Number.isNaN(Number(optionPosition))) return Number(optionPosition) - 1;
        const datasetIndex = input.dataset.index || input.getAttribute('data-index');
        if (datasetIndex && !Number.isNaN(Number(datasetIndex))) return Number(datasetIndex);
        const name = input.getAttribute('name') || '';
        const bracketNum = name.match(/\[(\d+)\]/);
        if (bracketNum && bracketNum[1]) return Number(bracketNum[1]);
        const optionNum = name.match(/option-?(\d+)/i);
        if (optionNum && optionNum[1]) return Number(optionNum[1]);
        return fallbackIndex;
      }

      _getLabelTextForInput(input) {
        const dataLabel = input.dataset.optionLabel;
        if (dataLabel) return dataLabel;
        const id = input.id;
        const labelByFor = id ? document.querySelector(`label[for="${id}"]`) : null;
        const labelEl = input.closest('label') || labelByFor;
        if (labelEl) return labelEl.textContent.trim();
        return input.value;
      }

      _getMainOptionValues() {
        const values = {};
        Object.entries(this.variantInputsByIndex).forEach(([idx, inputs]) => {
          inputs.forEach((input) => {
            if (input.type === 'radio') {
              if (input.checked) {
                values[idx] = this._getLabelTextForInput(input);
              }
            } else {
              values[idx] = input.value;
            }
          });
        });
        return values;
      }

      _syncFromMain() {
        const values = this._getMainOptionValues();
        this.variantSelects.forEach((select) => {
          const idx = select.dataset.optionIndex;
          if (idx === undefined) return;
          if (!(idx in values)) return;
          if (select.value !== values[idx]) {
            select.value = values[idx];
          }
        });
      }

      _syncToMain(optionIndex, value) {
        const inputs = this.variantInputsByIndex[optionIndex] || [];
        inputs.forEach((input) => {
          const labelValue = this._getLabelTextForInput(input);
          if (input.type === 'radio') {
            if (labelValue === value || input.value === value) {
              if (!input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          } else {
            if (input.value !== value) {
              input.value = value;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          }
        });
      }

      _onVariantSelectChange(event) {
        const select = event.target;
        const optionIndex = Number(select.dataset.optionIndex);
        if (Number.isNaN(optionIndex)) return;
        this._syncToMain(optionIndex, select.value);
      }

      _onMainVariantChange() {
        this._syncFromMain();
      }

      _onScroll() {
        // 确保在变体切换后仍有正确的按钮绑定
        this._ensureBinding();

        // 滚动到底部附近时隐藏
        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        // 如果不在底部，再根据加购可见性决定
        this._updateVisibility();
      }

      _isElementInViewport(el) {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return (
          rect.top < window.innerHeight &&
          rect.bottom > 0 &&
          rect.left < window.innerWidth &&
          rect.right > 0
        );
      }

      _hasScrolledToProductButton() {
        if (!this.addToCartEl) return true; // 如果没有按钮，认为已经滚动到
        const buttonRect = this.addToCartEl.getBoundingClientRect();
        const buttonTop = buttonRect.top + window.scrollY;
        // 检查是否已经滚动到按钮位置（按钮顶部已经在视口上方或可见）
        return window.scrollY >= buttonTop - window.innerHeight;
      }

      _showIfNotAtBottom() {
        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        this._show();
      }

      _updateVisibility() {
        if (!this.addToCartEl) {
          this._show();
          return;
        }

        const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - this.pageBottomOffset);
        if (nearBottom) {
          this._hide();
          return;
        }

        // 如果还没有滚动到产品主体按钮，也不显示
        if (!this._hasScrolledToProductButton()) {
          this._hide();
          return;
        }

        if (this._isElementInViewport(this.addToCartEl)) {
          this._hide();
        } else {
          this._show();
        }
      }

      _show() {
        this.tabEl.style.opacity = '1';
        this.tabEl.style.pointerEvents = 'auto';
      }

      _hide() {
        this.tabEl.style.opacity = '0';
        this.tabEl.style.pointerEvents = 'none';
      }
    }

    // 自定义 select 组件 - 完美继承原生 select 功能
    class YgCustomSelect extends HTMLElement {
      constructor() {
        super();
        this._value = '';
        this._options = [];
        this._selectedIndex = -1;
        this._isOpen = false;
      }

      static get observedAttributes() {
        return ['data-option-index', 'data-option-name'];
      }

      connectedCallback() {
        this._initOptions();
        this._render();
        this._attachEvents();
        this._updateSelectedDisplay();
        // 根据最长选项文本设置最小宽度
        try {
          this._setMinWidth();
        } catch (e) {
          // 忽略测量错误，避免阻断渲染
          console.error('yg-custom-select setMinWidth error', e);
        }
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-option-index' || name === 'data-option-name') {
          // 属性变化时不需要特殊处理，因为逻辑通过 value 控制
        }
      }

      _initOptions() {
        const optionElements = this.querySelectorAll('.yg-custom-select-option');
        this._options = Array.from(optionElements).map((opt, index) => {
          const value = opt.dataset.value || opt.textContent.trim();
          const isSelected = opt.dataset.selected === 'true' || opt.hasAttribute('data-selected');
          return {
            value: value,
            text: opt.textContent.trim(),
            element: opt,
            index: index
          };
        });

        // 找到初始选中项
        const selectedOption = this._options.find((opt, idx) => {
          const el = opt.element;
          return el.dataset.selected === 'true' || el.hasAttribute('data-selected');
        });

        if (selectedOption) {
          this._selectedIndex = selectedOption.index;
          this._value = selectedOption.value;
        } else if (this._options.length > 0) {
          this._selectedIndex = 0;
          this._value = this._options[0].value;
        }
      }

      _render() {
        // 检查是否已经渲染过
        if (this._trigger) return;

        const trigger = document.createElement('button');
        trigger.className = 'yg-custom-select-trigger';
        trigger.type = 'button';
        trigger.setAttribute('aria-haspopup', 'listbox');

        const text = document.createElement('span');
        text.className = 'yg-custom-select-text';
        trigger.appendChild(text);

        const arrow = document.createElement('span');
        arrow.className = 'yg-custom-select-arrow';
        arrow.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M4 6L8 10L12 6" stroke="#4B4C4D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        trigger.appendChild(arrow);

        const dropdown = document.createElement('div');
        dropdown.className = 'yg-custom-select-dropdown';
        dropdown.setAttribute('role', 'listbox');
        dropdown.hidden = true;

        // 将现有选项元素移动到 dropdown
        this._options.forEach((opt) => {
          opt.element.setAttribute('role', 'option');
          if (opt.index === this._selectedIndex) {
            opt.element.classList.add('selected');
          }
          dropdown.appendChild(opt.element);
        });

        this._trigger = trigger;
        this._text = text;
        this._dropdown = dropdown;

        this.appendChild(trigger);
        this.appendChild(dropdown);
      }

      _setMinWidth() {
        if (!this._options || this._options.length === 0) return;
        if (!this._trigger) return;

        // 使用 canvas 精确测量文字宽度，避免 clone 带来的样式差异
        const textEl = this._trigger.querySelector('.yg-custom-select-text') || this._trigger;
        const textStyle = window.getComputedStyle(textEl);
        const triggerStyle = window.getComputedStyle(this._trigger);

        const font = textStyle.font || `${textStyle.fontStyle} ${textStyle.fontWeight} ${textStyle.fontSize} ${textStyle.fontFamily}`;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.font = font;

        let maxTextWidth = 0;
        this._options.forEach((opt) => {
          const measured = Math.ceil(ctx.measureText(opt.text).width);
          if (measured > maxTextWidth) maxTextWidth = measured;
        });

        // 计算额外宽度：左右内边距、边框、箭头宽度、gap 等
        const paddingLeft = parseFloat(triggerStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(triggerStyle.paddingRight) || 0;
        const borderLeft = parseFloat(triggerStyle.borderLeftWidth) || 0;
        const borderRight = parseFloat(triggerStyle.borderRightWidth) || 0;
        const gap = parseFloat(triggerStyle.gap) || 8;
        // 箭头元素宽度（尝试测量实际元素）
        const arrowEl = this._trigger.querySelector('.yg-custom-select-arrow');
        let arrowWidth = 0;
        if (arrowEl) {
          const arrowStyle = window.getComputedStyle(arrowEl);
          arrowWidth = parseFloat(arrowStyle.width) || arrowEl.getBoundingClientRect().width || 0;
        } else {
          arrowWidth = 12;
        }

        const total = maxTextWidth + paddingLeft + paddingRight + borderLeft + borderRight + arrowWidth + gap + 2; // +2 作为容错
        this._trigger.style.minWidth = Math.ceil(total) + 'px';
      }

      _attachEvents() {
        // 点击触发按钮
        this._trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle();
        });

        // 点击选项
        this._options.forEach((opt) => {
          opt.element.addEventListener('click', (e) => {
            e.stopPropagation();
            this._selectOption(opt.index);
            this.close();
          });
        });

        // 点击外部关闭
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) {
            this.close();
          }
        });
      }

      _selectOption(index) {
        if (index < 0 || index >= this._options.length) return;
        if (this._selectedIndex === index) return;

        const oldValue = this._value;
        this._selectedIndex = index;
        this._value = this._options[index].value;

        // 更新选中状态
        this._options.forEach((opt, idx) => {
          if (idx === index) {
            opt.element.classList.add('selected');
            opt.element.setAttribute('data-selected', 'true');
          } else {
            opt.element.classList.remove('selected');
            opt.element.removeAttribute('data-selected');
          }
        });

        this._updateSelectedDisplay();

        // 触发 change 事件（兼容原生 select 行为）
        if (oldValue !== this._value) {
          this.dispatchEvent(new Event('change', { bubbles: true }));
          this.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }

      _updateSelectedDisplay() {
        if (this._selectedIndex >= 0 && this._selectedIndex < this._options.length) {
          this._text.textContent = this._options[this._selectedIndex].text;
        }
      }

      toggle() {
        if (this._isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        // 关闭其他 select
        document.querySelectorAll('yg-custom-select').forEach((select) => {
          if (select !== this) {
            select.close();
          }
        });

        this._isOpen = true;
        this.classList.add('open');
        this._dropdown.hidden = false;
      }

      close() {
        this._isOpen = false;
        this.classList.remove('open');
        this._dropdown.hidden = true;
      }

      // 实现原生 select 的 value 属性
      get value() {
        return this._value;
      }

      set value(newValue) {
        const index = this._options.findIndex((opt) => opt.value === newValue);
        if (index >= 0) {
          this._selectOption(index);
        }
      }

      // 实现原生 select 的 options 属性（类数组对象）
      get options() {
        const self = this;
        const optionsArray = this._options.map((opt, idx) => ({
          value: opt.value,
          text: opt.text,
          selected: idx === this._selectedIndex,
          index: idx
        }));

        // 创建类数组对象，支持 Array.from() 和 forEach 等
        const optionsObj = Object.create(Array.prototype);
        optionsArray.forEach((opt, idx) => {
          optionsObj[idx] = opt;
        });
        optionsObj.length = optionsArray.length;

        // 添加常用方法
        optionsObj.item = function(index) {
          return this[index] || null;
        };
        optionsObj.forEach = Array.prototype.forEach.bind(optionsArray);
        optionsObj.find = Array.prototype.find.bind(optionsArray);
        optionsObj.filter = Array.prototype.filter.bind(optionsArray);
        optionsObj.map = Array.prototype.map.bind(optionsArray);

        return optionsObj;
      }
    }

    if (!customElements.get('yg-custom-select')) {
      customElements.define('yg-custom-select', YgCustomSelect);
    }

    if (!customElements.get('yg-product-tab')) {
      customElements.define('yg-product-tab', YGProductTab);
    }
  })

  } catch(e) { console.error(e); }
})();
})();
